import React from 'react'
import PropTypes from 'prop-types'

import { withAppContext } from '../../utils/AppContext'
import Card from './Card'
import InputRangeWrap from '../InputRangeWrap'

const TraitsHandCard = ({ appContext }) => (
    <Card title="Hand of the King/Queen">
        {/* <h3>Qualities You Prize</h3> */}
        <InputRangeWrap
            labelA="Realist"
            labelB="Idealist"
            max={10}
            min={0}
            value={appContext.scoreCalculator.getData('handWeights').pragmatic}
            onChange={
                value => {
                    appContext.setContextState({ isActive: 'handScore' })
                    return appContext.scoreCalculator.onUpdateCategory('pragmatic', value, 'handWeights')
                }
            }
        />
        <InputRangeWrap
            labelA="Selfish"
            labelB="Selfless"
            max={10}
            min={0}
            value={appContext.scoreCalculator.getData('handWeights').selfish}
            onChange={
                value => {
                    appContext.setContextState({ isActive: 'handScore' })
                    return appContext.scoreCalculator.onUpdateCategory('selfish', value, 'handWeights')
                }
            }
        />
        <InputRangeWrap
            labelA="Image is Important"
            labelB="Action is Important"
            max={10}
            min={0}
            value={appContext.scoreCalculator.getData('handWeights').appearance}
            onChange={
                value => {
                    appContext.setContextState({ isActive: 'handScore' })
                    return appContext.scoreCalculator.onUpdateCategory('appearance', value, 'handWeights')
                }
            }
        />
    </Card>
)

TraitsHandCard.propTypes = {
    appContext: PropTypes.object.isRequired,
}

export default withAppContext(TraitsHandCard)



// WEBPACK FOOTER //
// ./src/ui/CarouselCards/TraitsHandCard.js